import styled from 'styled-components';
import { ButtonProps } from '@sleepunique/types/button-type';

export const ButtonComponent = styled.button<ButtonProps>`
  display: inline-flex;
  color: var(--color-base-white);
  gap: 1.125rem;
  background-color: transparent;
  border: none;
  align-items: center;
  vertical-align: middle;
  justify-content: center;
  padding: 0.25rem 0;
  cursor: pointer;
  font-size: 1.125rem;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 1;
  text-align: center;
  text-decoration: none;
  transition: 0.3s;
  border-radius: 1.5625rem;
  ${({ iconLeft }) => (iconLeft ? `flex-direction: row-reverse;` : ``)}

  path: {
    transition: 0.3s;
  }

  &:hover {
    color: var(--color-sleepunique-red);
    path {
      fill: var(--color-sleepunique-red);
    }
  }

  &:active {
    color: var(--color-sleepunique-red);
  }

  &:disabled {
    background-color: var(--color-tints-dusky-blue);
    border-color: var(--color-tints-dusky-blue);
    pointer-events: none;
  }
`;

export const ButtonText = styled.span`
  font-size: 1.125rem;
  letter-spacing: 0;
  line-height: 1rem;
`;

export const IconContainer = styled.div`
  color: var(--color-base-white);
  margin-left: 1.125rem;
  display: flex;
`;
